<template>
  <div class="min-h-screen bg-gradient-to-br from-gray-900 to-gray-800 text-white">

    <!-- Contact Form Section -->
    <section id="contactusform" class="container mx-auto py-20">
      <h1 class="text-4xl font-bold mb-8 text-center">Contact Us</h1>
      <div class="max-w-2xl mx-auto bg-gray-800 p-8 rounded-lg shadow-lg">
        <form @submit.prevent="submitForm" class="space-y-6">
          <div>
            <label for="name" class="block text-sm font-medium text-gray-300">Name</label>
            <input type="text" id="name" v-model="form.name" required
                   class="mt-1 block w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded-md text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent">
          </div>
          <div>
            <label for="email" class="block text-sm font-medium text-gray-300">Email</label>
            <input type="email" id="email" v-model="form.email" required
                   class="mt-1 block w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded-md text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent">
          </div>
          <div>
            <label for="message" class="block text-sm font-medium text-gray-300">Message</label>
            <textarea id="message" v-model="form.message" rows="4" required
                      class="mt-1 block w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded-md text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent"></textarea>
          </div>
          <div>
            <button type="submit"
                    class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500">
              Send Message
            </button>
          </div>
        </form>
      </div>
    </section>

    <!-- Contact Information -->
    <section class="container mx-auto py-20">
      <div class="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8">
        <div class="bg-gray-800 p-6 rounded-lg shadow-lg">
          <h2 class="text-2xl font-bold mb-4">Our Office</h2>
          <p class="mb-2">545 8th Ave</p>
          <p class="mb-2">New York, NY 10018</p>
          <p>United States</p>
        </div>
        <div class="bg-gray-800 p-6 rounded-lg shadow-lg">
          <h2 class="text-2xl font-bold mb-4">Contact Information</h2>
          <p class="mb-2">Phone: +1 201-535-4923 </p>

        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const form = ref({
  name: '',
  email: '',
  message: ''
})

// Updated submitForm function
const submitForm = async () => {
  try {
    const response = await fetch('/contact', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(form.value)
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    } else {
      const jsonData = await response.json();
      console.log('Message from the server: ', jsonData.status);

      // Reset form after successful submission
      form.value = { name: '', email: '', message: '' };
      alert('Thank you for your message. We will get back to you soon!');
    }
  } catch (error) {
    console.error('There was a problem with the fetch operation: ' + error.message);
  }
}
</script>
<style scoped>
/* Add any additional component-specific styles here */
.bg-gradient-to-br {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}

.from-gray-900 {
  --tw-gradient-from: #111827;
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgba(17, 24, 39, 0));
}

.to-gray-800 {
  --tw-gradient-to: #1f2937;
}

.text-green-400 {
  --tw-text-opacity: 1;
  color: rgba(52, 211, 153, var(--tw-text-opacity));
}

.bg-green-600 {
  --tw-bg-opacity: 1;
  background-color: rgba(5, 150, 105, var(--tw-bg-opacity));
}

.hover\:bg-green-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(4, 120, 87, var(--tw-bg-opacity));
}

/* Add any additional custom styles here */
</style>

